// src/localStorageUtil.ts
//
// 通用 localStorage 工具，用于真正需要"跨会话持久化"的场景：
// - 用户登录态（token、userInfo）
// - 主题、语言、用户偏好设置
// - 上次学习进度等需要跨标签页/跨会话恢复的数据
//
// 一次性的"页面间传递批次"请使用 @/utils/batchStorage（基于 sessionStorage）。

class LocalStorageUtil {
  // 写入值。返回是否写入成功，便于调用方在配额超限等场景下做兜底处理。
  static setItem(key: string, value: any): boolean {
    try {
      const stringValue = JSON.stringify(value);
      localStorage.setItem(key, stringValue);
      return true;
    } catch (error) {
      console.error(`Error setting item ${key} in localStorage`, error);
      return false;
    }
  }

  // 读取值
  static getItem<T>(key: string): T | null {
    try {
      const stringValue = localStorage.getItem(key);
      if (stringValue === null) {
        return null;
      }
      return JSON.parse(stringValue) as T;
    } catch (error) {
      console.error(`Error getting item ${key} from localStorage`, error);
      return null;
    }
  }

  // 删除值
  static removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item ${key} from localStorage`, error);
    }
  }

  // 清空 localStorage
  static clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Error clearing localStorage", error);
    }
  }
}

export default LocalStorageUtil;
